import React, {useMemo} from 'react';
import {Box} from '@mui/material';
import {
  Body,
  designSystemToken,
  Icon,
  Tooltip,
} from '@lightricks/react-design-system';
import ErrorsTooltip from '@contentlab/components/asset-card/components/errors-tooltip';
import {FlowStatus} from '@contentlab/types/project';
import {AssetError} from '@contentlab/types/projectProps';
import translate from '@/utils/translate';

interface StatusBadgeProps {
  status: FlowStatus;
  errors?: AssetError[];
}

const STATUS_COLOR_MAP = () => ({
  ready: designSystemToken('semantic.fg.success'),
  failed: designSystemToken('semantic.fg.danger'),
});

function StatusBadge(props: StatusBadgeProps) {
  const {status, errors} = props;

  const statusString = useMemo(() => {
    switch (status) {
      case 'failed':
        return translate('Failed count', {
          postProcess: 'interval',
          count: errors?.length || 0,
        });
      default:
        return null;
    }
  }, [status, errors]);

  const statusColor = useMemo(() => {
    const colorMap = STATUS_COLOR_MAP();
    if (status in colorMap) {
      return colorMap[status as keyof typeof colorMap];
    }
    return designSystemToken('semantic.fg.primary');
  }, [status]);

  return (
    <Box display="flex" flexDirection="row" gap="2px">
      {statusString ? (
        <Body size="md" color={statusColor}>
          {statusString}
        </Body>
      ) : null}
      {status === 'failed' && errors?.length ? (
        <ErrorsTooltip errors={errors} />
      ) : null}
    </Box>
  );
}

export default StatusBadge;
